module.exports = __webpack_public_path__ + "static/logo_primark-27a8dae7de1ab1a682067b3d20dc7514.png";